import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=6436bb49&scoped=true&"
import script from "./ExpandTransition.vue?vue&type=script&lang=js&"
export * from "./ExpandTransition.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTransition.vue?vue&type=style&index=0&id=6436bb49&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436bb49",
  null
  
)

export default component.exports